import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import './LandingPageColumns.css'
import YouTube from 'react-youtube'



export default class ProductLandingHero extends Component {
    state = {

    }



    componentDidMount() {

    }

    render() {
        const {
            columnLeft,
            columnRight,
            youtubeId,
            titleLeft,
            titleRight
        } = this.props



        return (
            <Wrapper>
                <Content>
                    <Container fluid className="height100">
                        <Row className="landing-page-columns-row">
                            <Col col={12} lg={3} className="text-border column">
                                <TextWrapper className="text-wrapper">
                                    <Title>{titleLeft}</Title>
                                    <Text dangerouslySetInnerHTML={{ __html: columnLeft }}></Text>
                                </TextWrapper>
                            </Col>
                            <Col col={12} lg={6} className="video-column column">
                                <YouTubeContainer>
                                    <YouTube videoId={youtubeId} opts={{
                                        playerVars: {
                                            autoplay: 0,
                                        }
                                    }} />

                                </YouTubeContainer>
                            </Col>
                            <Col col={12} lg={3} className="text-border column">
                                <TextWrapper className="text-wrapper">
                                    <Title>{titleRight}</Title>
                                    <Text dangerouslySetInnerHTML={{ __html: columnRight }}></Text>
                                </TextWrapper>
                            </Col>
                        </Row>
                    </Container>
                </Content>
            </Wrapper>
        )
    }
}

// Styles
const Wrapper = styled.section`
  background: url(${props => props.image}) center / cover;
  display: flex;
  align-items: flex-start;
  padding-top: 5%;
  padding-bottom: 50px;
  position: relative;
  margin-bottom: 65px;
`

const Content = styled.div`
  height: 100%;
  position: relative;
  z-index: 1;
  width: 100%;
`

const Text = styled.div`
font-size: 20px;
color: black;
font-weight: 300;
`
const Title = styled.h2`
color: #00994c;
font-size: 1.7rem;
`

const TextWrapper = styled.div`
width: 100%;
`

const YouTubeContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    width: 100%;
    position: relative;
  }

  iframe {
    width: 100%;
  }
`


// WEBPACK FOOTER //
// ./src/ui/components/modules/LandingPageColumns/index.js